import { handleMutationError } from '@ui/utils/handleMutationError';
import { useTranslation } from 'next-i18next';
import { useCallback, useState } from 'react';

import { useMutationToast } from './useMutationToast';

export const useSimulateMutation = () => {
  const [isSimulating, setIsSimulating] = useState(false);
  const { t } = useTranslation();
  const toast = useMutationToast();

  const simulate = useCallback(
    async (mutation: () => Promise<unknown>) => {
      try {
        setIsSimulating(true);
        await mutation();

        return {
          isSuccess: true,
        };
      } catch (err) {
        handleMutationError(err, (m) => toast.onError({ errorMsg: m }), t);

        return {
          isSuccess: false,
        };
      } finally {
        setIsSimulating(false);
      }
    },
    [t, toast],
  );

  return {
    isSimulating,
    simulate,
  };
};
